console.log('[Ace Streamz] index.web.js starting...');

// Check if we're on an OAuth callback page - if so, don't load the React app
// The static HTML callback page should handle the OAuth flow
if (window.location.pathname.includes('/auth/google/callback') ||
    window.location.pathname.includes('/auth/apple/callback')) {
  console.log('[Ace Streamz] OAuth callback detected, skipping React app load');
  // Let the static HTML page handle this
  if (!document.getElementById('root')) {
    document.body.innerHTML = '<div id="root"></div>';
  }
  // Exit early - don't load the React app
  throw new Error('SKIP_REACT_APP_LOAD');
}

// Global error handler
window.onerror = function(message, source, lineno, colno, error) {
  // Skip logging for intentional skips
  if (message.includes('SKIP_REACT_APP_LOAD')) {
    return true;
  }
  console.error('[Ace Streamz] Global error:', message, source, lineno, colno, error);
  document.getElementById('root').innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;background:#0B0F14;color:#fff;font-family:sans-serif;">
      <h1 style="color:#e94560;">Error Loading App</h1>
      <p style="color:#9CA3AF;max-width:600px;text-align:center;">${message}</p>
      <p style="color:#6B7280;font-size:12px;">Check console (F12) for details</p>
    </div>
  `;
  return true;
};

// Unhandled promise rejection handler
window.onunhandledrejection = function(event) {
  console.error('[Ace Streamz] Unhandled promise rejection:', event.reason);
};

try {
  console.log('[Ace Streamz] Importing React...');
  const React = require('react');
  console.log('[Ace Streamz] React imported OK');

  console.log('[Ace Streamz] Importing ReactDOM...');
  const { createRoot } = require('react-dom/client');
  console.log('[Ace Streamz] ReactDOM imported OK');

  console.log('[Ace Streamz] Importing App...');
  const App = require('./App.web').default;
  console.log('[Ace Streamz] App imported OK');

  const container = document.getElementById('root');
  console.log('[Ace Streamz] Root container found:', !!container);

  if (container) {
    container.innerHTML = '';
    const root = createRoot(container);
    console.log('[Ace Streamz] Rendering app...');
    root.render(React.createElement(App));
    console.log('[Ace Streamz] App rendered successfully');
  } else {
    console.error('[Ace Streamz] Root container not found!');
  }
} catch (error) {
  console.error('[Ace Streamz] Fatal error:', error);
  document.getElementById('root').innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;background:#0B0F14;color:#fff;font-family:sans-serif;">
      <h1 style="color:#e94560;">Fatal Error</h1>
      <p style="color:#9CA3AF;max-width:600px;text-align:center;">${error.message}</p>
      <pre style="color:#6B7280;font-size:10px;max-width:80%;overflow:auto;">${error.stack}</pre>
    </div>
  `;
}
